"use strict";

require("core-js/modules/es.object.define-property.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

require("core-js/modules/es.function.name.js");

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

require("element-ui/lib/theme-chalk/src/base.css");

require("element-ui/lib/theme-chalk/src/tooltip.css");

var _tooltip2 = _interopRequireDefault(require("element-ui/lib/tooltip"));

var _skUtils = require("sk-utils");

var _utils = require("sk-web-framework/utils");

var _trackTask = _interopRequireDefault(require("sk-web-framework/utils/trackTask"));

var _vuex = require("vuex");

var __vue_render__ = function __vue_render__(h) {
  var _vm = this;

  var _h = _vm.$createElement;
  var _c = h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading.action",
      value: _vm.inprocessing,
      expression: "inprocessing",
      modifiers: {
        "action": true
      }
    }],
    "class": _vm.language,
    attrs: {
      "id": "app",
      "element-loading-text": _vm.$t('ing')
    }
  }, [_vm.isRouterAlive ? _c('router-view') : _vm._e(), _vm._v(" "), _c('el-tooltip', {
    ref: "sk-v-tooltip",
    attrs: {
      "dangerously-use-h-t-m-l-string": false,
      "effect": "dark",
      "placement": "top"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  })])], 1);
};

var __vue_staticRenderFns__ = [];
var _default = {
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__,
  name: 'APP',
  components: (0, _defineProperty2["default"])({}, _tooltip2["default"].name, _tooltip2["default"]),
  mixins: [_trackTask["default"]],
  data: function data() {
    return {
      content: '',
      isRouterAlive: true
    };
  },
  computed: (0, _objectSpread2["default"])({}, (0, _vuex.mapGetters)(['language', 'inprocessing'])),
  watch: {
    $route: function $route(to, from) {
      this.$store.dispatch('changeView', to.name);
    }
  },
  mounted: function mounted() {
    var _this = this;

    // this.resize();
    this.$root.tooltip = this.$refs['sk-v-tooltip'];
    this.$root.reload = this.reload;
    this.__resizeFontSizeHandle = (0, _utils.debounce)(function () {
      _this.$store.dispatch('setLowResolution', (0, _skUtils.isBottomWidthResolution)());

      _this.$store.dispatch('setHtmlFontBaseSize', (0, _skUtils.updateFontSizeInHtml)());
    }, 30);

    this.__resizeFontSizeHandle();

    (0, _skUtils.on)(window, 'resize', this.__resizeFontSizeHandle);
  },
  destroyed: function destroyed() {
    (0, _skUtils.off)(window, 'resize', this.__resizeFontSizeHandle);
  },
  methods: {
    reload: function reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    } // resize() {
    //   // // 设计图尺寸
    //   // const designSize = 1920;
    //   // // 窗口宽度
    //   // const clientWidth = document.documentElement.clientWidth;
    //   // // 计算rem
    //   // let rem = clientWidth * 14 / designSize;
    //   // // 最小 1rem = 10px
    //   // rem = `${rem}px`;
    //   // document.documentElement.style.fontSize = rem;
    //   // this.$root.tooltip = this.$refs['sk-v-tooltip'];
    // }

  }
};
exports["default"] = _default;